import { LitElement, html, svg } from 'lit';

export class IconGraphPie24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Kakediagram</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M22.5 10.5h-9v-9a9 9 0 0 1 9 9Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5a9 9 0 1 0 9 9h-9v-9Z"></path></svg>`; }
}
if (!customElements.get('f-icon-graph-pie24', IconGraphPie24)) {
  customElements.define('f-icon-graph-pie24', IconGraphPie24);
}